import { render, staticRenderFns } from "./InstitutionDetails.vue?vue&type=template&id=ffb45cda&scoped=true"
import script from "./InstitutionDetails.vue?vue&type=script&lang=js"
export * from "./InstitutionDetails.vue?vue&type=script&lang=js"
import style0 from "./InstitutionDetails.vue?vue&type=style&index=0&id=ffb45cda&prod&scoped=true&lang=css"
import style1 from "./InstitutionDetails.vue?vue&type=style&index=1&id=ffb45cda&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffb45cda",
  null
  
)

export default component.exports